import { DeliveryFulfillmentType } from "../../form/formTypes"
import { SatelliteType } from "../../../createOrderTypes"

export function mapDeliveryToSatelliteType(delivery: DeliveryFulfillmentType | null): SatelliteType | null {
    switch (delivery) {
        case DeliveryFulfillmentType.EATING_IN_CANTEEN:
            return SatelliteType.EAT_AT_LOCATION
        case DeliveryFulfillmentType.PICK_UP:
            return SatelliteType.PICKUP_LOCATION
        case DeliveryFulfillmentType.DELIVERY:
            return SatelliteType.DELIVERY_LOCATION
        default:
            return null
    }
}
